import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SidePanelType } from '@easy-lib/modules/shared/models';

@Injectable({
	providedIn: 'root'
})
export class SidePanelServiceService {
	private openSidePanelWithDataSubject = new BehaviorSubject<{
		sidePanel: SidePanelType;
		data?: any;
		value?: string;
	}>(null);
	openSidePanelWithData$ = this.openSidePanelWithDataSubject.asObservable();
	private closeSidePanelSubject = new Subject<boolean>();
	closeSidePanel$ = this.closeSidePanelSubject.asObservable();
	closeSidePanel = (value = true) => this.closeSidePanelSubject.next(value);
	openSidePanelFromRoute(data: { sidePanel: SidePanelType; data?: any; value?: string }) {
		this.openSidePanelWithDataSubject.next(data);
	}
}
